import ModalNewAnnouncement from "./ModalNewAnnouncement";

export default ModalNewAnnouncement;
